if (!customElements.get('quick-buy-popup')) {
  customElements.define(
    'quick-buy-popup',
    class QuickBuyPopup extends HTMLElement {
      constructor() {
        super();

        this.dialogElement = this.querySelector('[data-quick-buy-dialog]');
        this.imageElement = this.querySelector('[data-quick-buy-image]');
        this.titleElement = this.querySelector('[data-quick-buy-title]');
        this.priceElement = this.querySelector('[data-quick-buy-price]');
        this.comparePriceElement = this.querySelector('[data-quick-buy-compare-price]');
        this.unitPriceElement = this.querySelector('[data-quick-buy-unit-price]');
        this.addButtonElement = this.querySelector('[data-quick-buy-add-button]');
        this.closeTimeout = null;
        this.isClosing = false;

        this.onPickerChange = this.onPickerChange.bind(this);

        this.querySelector('[data-quick-buy-open]')?.addEventListener('click', this.openPopup.bind(this));
        this.querySelector('[data-quick-buy-close]')?.addEventListener('click', this.closePopup.bind(this));
        this.dialogElement?.addEventListener('click', this.onDialogClick.bind(this));
        this.dialogElement?.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.closePopup();
        });
        this.addButtonElement?.addEventListener('click', this.onAddButtonClick.bind(this));
      }

      connectedCallback() {
        document.addEventListener('fake-variant-picker:change', this.onPickerChange);
      }

      disconnectedCallback() {
        document.removeEventListener('fake-variant-picker:change', this.onPickerChange);
        window.clearTimeout(this.closeTimeout);
        if (this.dialogElement?.open) this.unlockPageScroll();
      }

      openPopup(event) {
        event.preventDefault();
        event.stopPropagation();
        if (!this.dialogElement || this.dialogElement.open) return;

        window.clearTimeout(this.closeTimeout);
        this.isClosing = false;
        this.dialogElement.showModal();
        this.lockPageScroll();
        this.dialogElement.getBoundingClientRect();
        this.dialogElement.classList.add('is-open');
      }

      closePopup() {
        if (!this.dialogElement?.open || this.isClosing) return;

        const shouldAnimate = window.matchMedia('(max-width: 749px) and (prefers-reduced-motion: no-preference)').matches;
        if (!shouldAnimate) {
          this.finishClose();
          return;
        }

        this.isClosing = true;
        this.dialogElement.classList.remove('is-open');
        const onTransitionEnd = (event) => {
          if (event.target !== this.dialogElement || event.propertyName !== 'transform') return;

          this.dialogElement.removeEventListener('transitionend', onTransitionEnd);
          this.finishClose();
        };

        this.dialogElement.addEventListener('transitionend', onTransitionEnd);
        window.clearTimeout(this.closeTimeout);
        this.closeTimeout = window.setTimeout(() => {
          this.dialogElement.removeEventListener('transitionend', onTransitionEnd);
          this.finishClose();
        }, 300);
      }

      finishClose() {
        window.clearTimeout(this.closeTimeout);
        this.closeTimeout = null;
        this.isClosing = false;
        this.dialogElement.classList.remove('is-open');
        if (this.dialogElement.open) this.dialogElement.close();
        this.unlockPageScroll();
      }

      lockPageScroll() {
        document.documentElement.classList.add('quick-buy-scroll-locked');
      }

      unlockPageScroll() {
        document.documentElement.classList.remove('quick-buy-scroll-locked');
      }

      onDialogClick(event) {
        const isBackdropClick = event.target === this.dialogElement;
        if (isBackdropClick) this.closePopup();
      }

      onAddButtonClick() {
        if (!this.addButtonElement.hasAttribute('data-action-atc')) return;

        this.closePopup();
      }

      onPickerChange(event) {
        if (event.detail.pickerId !== this.dataset.pickerId) return;

        this.updateProductDetails(event.detail.product);
      }

      updateProductDetails(product) {
        if (this.titleElement) this.titleElement.textContent = product.title;
        if (this.priceElement) this.priceElement.innerHTML = product.price;
        this.updateComparePrice(product.compareAtPrice);
        this.updateUnitPrice(product.unitPrice);
        this.updateImage(product);
        this.updateAddButton(product);
      }

      updateComparePrice(compareAtPrice) {
        if (!this.comparePriceElement) return;

        this.comparePriceElement.innerHTML = compareAtPrice || '';
        this.comparePriceElement.hidden = !compareAtPrice;
      }

      updateUnitPrice(unitPrice) {
        if (!this.unitPriceElement) return;

        this.unitPriceElement.textContent = unitPrice || '';
        this.unitPriceElement.hidden = !unitPrice;
      }

      updateImage(product) {
        if (!this.imageElement || !product.image) return;

        this.imageElement.removeAttribute('srcset');
        this.imageElement.src = product.image;
        this.imageElement.alt = product.imageAlt || product.title;
      }

      updateAddButton(product) {
        if (!this.addButtonElement) return;

        this.addButtonElement.href = product.url;
        this.addButtonElement.dataset.variantId = product.variantId;
        this.addButtonElement.toggleAttribute('data-action-atc', product.available);
        this.addButtonElement.textContent = product.available
          ? this.addButtonElement.dataset.addToCartText
          : this.addButtonElement.dataset.soldOutText;
      }
    }
  );
}
